import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RouteComponentProps } from "react-router";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";
import * as httpClient from "../../util/httpClient";
import { useForm } from "react-hook-form";
import { DialogComponent } from "./../common/DialogComponent";
import MFAInfoDialog from "../Dialogs/MFAInfoDialog";
import { GetServiceDetails } from "../../store/loginService/actions";
import { emailMasking } from "../../util/CommonReadonlyMasking";
import { useTranslation } from "react-i18next";
type VerifyLoginMFAProps = RouteComponentProps<{}>;

interface IState {
    isSaveCookie: string;
    errorMessage: string;
    selectedMethodObj: any;
    isLoading: boolean;
    type: string;
}

const VerifyLoginMFA: React.FunctionComponent<VerifyLoginMFAProps> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const userInfo = useSelector((state: ApplicationState) => (state.loggedInUser ? state.loggedInUser.userInfo : null));
    const dispatch = useDispatch();
    const appState = useSelector((state: ApplicationState) => state);
    const [state, setState] = useState<IState>({ isSaveCookie: "", errorMessage: "", selectedMethodObj: {}, isLoading: false, type: "" });
    const { register, errors, handleSubmit, formState } = useForm({
        mode: "onChange",
    });
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const { isValid } = formState;
    const [showDialog, setShowDialog] = useState(false);
    const [logoHTML, setLogoHTML] = useState("");

    const selectedMethod = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.selectedMethod ? state.loggedInUser.selectedMethod : ""
    );
    const secureCode = useSelector((state: ApplicationState) => (state.loggedInUser && state.loggedInUser.secureCode ? state.loggedInUser.secureCode : ""));
    const preferredCommunicationMediaList = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.communicationMethodList ? state.loggedInUser.communicationMethodList : []
    );
    const forcePasswordUpdate = useSelector(
        (state: ApplicationState) => (state.loggedInUser && state.loggedInUser.userInfo && state.loggedInUser.userInfo.forcePasswordUpdate) || false
    );
    const isPasswordExpired = useSelector(
        (state: ApplicationState) => (state.loggedInUser && state.loggedInUser.userInfo && state.loggedInUser.userInfo.isPasswordExpired) || false
    );
    const fromRedirectUrl = useSelector((state: ApplicationState) => state.checkContractChangeState.fromRedirectUrl || false);
    let footerLogoHTML: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerProvider
            ? state.configurationState.configuration.partnerConfig.footerLogoHTML
            : ""
    );

    const isOneTrustPartner = useSelector((state: ApplicationState) => {
        const partnerId = state.configurationState?.configuration?.partnerConfig?.partnerId;
        return partnerId != null && [2649, 1557].includes(partnerId);
    });
    useEffect(() => {
        window.scrollTo(0, 0);
        if (preferredCommunicationMediaList && preferredCommunicationMediaList.length > 0) {
            let selectedMethodObj = preferredCommunicationMediaList.find((method) => {
                if (method.methodType === selectedMethod) {
                    return method.recepientAddress;
                }
            });
            setState({ ...state, selectedMethodObj: selectedMethodObj });
        }

        if (footerLogoHTML) {
            const domParser = new DOMParser();
            const parsedDoc = domParser.parseFromString(footerLogoHTML, 'text/html');
            let imgElement = parsedDoc.querySelector('img');
            if (imgElement) {
                imgElement.setAttribute('alt', 'Logo');
                footerLogoHTML = parsedDoc.documentElement.innerHTML;
                setLogoHTML(footerLogoHTML);
            }
        }
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    useEffect(() => {
        if (isOneTrustPartner) {
            var CookiePrefFooterLink = document.getElementById("cookie-pref-footer-link");
            if (CookiePrefFooterLink != null) {
                CookiePrefFooterLink.remove();
            }
        }
    }, []);

    const handleCloseDialog = (): any => {
        setShowDialog(false);
    };

    const handleChange = (e: any) => {
        setState({
            ...state,
            [e.target.name]: e.target.value,
        });
    };

    const handleChangeInput = (e: any) => {
        e.preventDefault();
        if (state.errorMessage.length > 0) {
            setState({ ...state, errorMessage: "" });
        }
    };

    const handleStaticClick = (type: string) => {
        setState({ ...state, type: type });
        setShowDialog(true);
    };

    const getData = () => {
        if (state.type === "MFA") {
            return {
                header: tLang("generateMfa.whatMFALinkText"),
                description1: tLang("generateMfa.whatIsMFAText.description1"),
                description2: tLang("generateMfa.whatIsMFAText.description2"),
            };
        } else {
            return {
                header: tLang("generateMfa.whatIsVerificationCode"),
                description1: tLang("generateMfa.whatIsVerificationCodeText.description1"),
                description2: tLang("generateMfa.whatIsVerificationCodeText.description2"),
            };
        }
    };

    const onSubmit = (data: any) => {
        setState({ ...state, errorMessage: "", isLoading: true });
        window.addToDataLayer({ event: "Verify Login MFA" });
        const requestBody = {
            SecurityCode: data.temporaryPassword,
            isSaveCookie: state.isSaveCookie === "true" ? true : false,
        };

        httpClient.sendRequest("POST", "web/login/VerifyMFALogin", requestBody).then((data) => {
            if (!data["hasError"] && !data["returnTOLoginpage"]) {
                if (forcePasswordUpdate || isPasswordExpired) {
                    setState({ ...state, isLoading: false });
                    props.history.push({
                        pathname: "/reset-password",
                    });
                    return;
                } else {
                    GetServiceDetails(dispatch, props.history, fromRedirectUrl, "", appState);
                    return;
                }
            }
            if (data.returnTOLoginpage) {
                setState({ ...state, isLoading: false });
                props.history.push({
                    pathname: "/Login",
                    state: { isFailedVerification: true },
                });
            }
            if (data["hasError"]) {
                setState({ ...state, isLoading: false, errorMessage: tLang("verifyMfa.incorrectVerificationCode") });
                return;
            }
        });
    };

    const maskedField = (field: any) => {
        if (field) {
            let index = field.length - 4;
            let maskedFields = field.slice(0, index);
            return field.replace(maskedFields, "******");
        }
    };

    const handleClick = () => {
        if (preferredCommunicationMediaList && Array.isArray(preferredCommunicationMediaList) && preferredCommunicationMediaList.length >= 2) {
            props.history.push("/generate-MFA");
        } else {
            setState({ ...state, isLoading: true });
            const requestBody = {
                NotificationMethod: 0,
                SecurityCode: secureCode,
            };

            httpClient.sendRequest("POST", "web/login/send-mfa-secureCode", requestBody).then((data) => {
                setState({ ...state, isLoading: false });
                dispatch({ type: "SELECT_COMMUNICATION_METHOD", selectedMethod: "EMAIL" });
            });
        }
    };

    return (
        <React.Fragment>
            <div id="l-page-content">
                <div className="l-page-container">
                    <div className=" row">
                        <div className="col-xs-12">
                            <h1 className="title-page sr-only" id="title-page">
                                Member Login
                            </h1>
                        </div>
                    </div>
                    <div className="row" id="content">
                        <div className="col-xs">
                            <div className={state.isLoading ? "box box-has-shadow box-xs offset-padding loading" : "box box-has-shadow box-xs offset-padding"}>
                                <div className="box-header">
                                    <div className="box-title-container">
                                        <div className="box-title-icon" aria-hidden="true">
                                            <em className="las la-exclamation-triangle"></em>
                                        </div>
                                        <div className="box-title-text">
                                            <h2 className="box-title">{tLang("generateMfa.title")}</h2>
                                        </div>
                                    </div>

                                    {selectedMethod === "EMAIL" && (
                                        <div className="box-description">
                                            <p
                                                dangerouslySetInnerHTML={{
                                                    __html: tLang("verifyMfa.para1").replace(
                                                        "dynamiceValue",
                                                        `<strong>${userInfo && userInfo.EmailAddress && emailMasking(userInfo.EmailAddress)}</strong>`
                                                    ),
                                                }}
                                            >
                                                {/* {tLang('verifyMfa.para1').replace('dynamiceValue', `<strong>${userInfo && userInfo.EmailAddress && emailMasking(userInfo.EmailAddress)}</strong>`)} */}
                                                {/* Use the Temporary Verification Code we sent to <strong>{userInfo && userInfo.EmailAddress && emailMasking(userInfo.EmailAddress)}</strong> to continue to your dashboard. If you did not receive your code, make sure to check your spam folder. */}
                                            </p>
                                            <p>{tLang("verifyMfa.para2")}</p>
                                        </div>
                                    )}
                                    {(selectedMethod === "SMS" || selectedMethod === "Call") && (
                                        <div className="box-description">
                                            <p>
                                                {tLang("verifyMfa.para3")}{" "}
                                                <strong>{maskedField(state.selectedMethodObj && state.selectedMethodObj.recepientAddress)}</strong> {tLang("verifyMfa.para4")}
                                            </p>

                                        </div>
                                    )}
                                </div>
                                <div className="box-content">
                                    <form id="form-member-login" onSubmit={handleSubmit(onSubmit)}>
                                        <div className="form-row">
                                            <div className="form-label">
                                                <label htmlFor="email-label">{tLang("verifyMfa.enterVerificationCode")}:</label>
                                            </div>
                                            <div className="form-input">
                                                <input
                                                    type="text"
                                                    id="email-label"
                                                    className={errors.temporaryPassword ? "status-error inputbox" : "inputbox"}
                                                    ref={register({ required: true })}
                                                    maxLength={6}
                                                    name="temporaryPassword"
                                                    onKeyUp={(e) => handleChangeInput(e)}
                                                />
                                                {errors.temporaryPassword && errors.temporaryPassword.type === "required" && (
                                                    <span role="alert" className="form-error">
                                                        <p>{tLang("verifyMfa.required")}</p>
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="margin-bottom-s"></div>

                                        <div className="form-row">
                                            <div className="form-input">
                                                <label className="form-radio-label">
                                                    <input
                                                        type="radio"
                                                        id="verify-email-1"
                                                        name="isSaveCookie"
                                                        value="false"
                                                        onChange={(e: any) => handleChange(e)}
                                                        checked={state.isSaveCookie === "false"}
                                                    />
                                                    <span className="form-radio-label-text">{tLang("verifyMfa.radioButtonLabel1")} </span>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="form-input">
                                                <label className="form-radio-label">
                                                    <input
                                                        type="radio"
                                                        id="verify-email-2"
                                                        name="isSaveCookie"
                                                        value="true"
                                                        onChange={(e: any) => handleChange(e)}
                                                        checked={state.isSaveCookie === "true"}
                                                    />
                                                    <span className="form-radio-label-text">{tLang("verifyMfa.radioButtonLabel2")}</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <button
                                                type="submit"
                                                disabled={!isValid || state.isSaveCookie.length === 0}
                                                className="btn-default btn-primary btn-min-width"
                                            >
                                                <span className="btn-text">{tLang("generateMfa.submitButtonText")}</span>
                                            </button>
                                        </div>

                                        {state.errorMessage.length > 0 && (
                                            <span role="alert" className="form-error">
                                                <p>{state.errorMessage}</p>
                                            </span>
                                        )}

                                        <div className="margin-vertical-l"></div>

                                        <p>
                                            <a
                                                href="#"
                                                className="default_link"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleClick();
                                                    window.addToDataLayer({ event: "Resend your Temporary Verification Code" });
                                                }}
                                            >
                                                {tLang("verifyMfa.resendCodeLinkText")}
                                            </a>
                                        </p>
                                        <p>
                                            <a
                                                href="#"
                                                className="default_link"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleStaticClick("MFA");
                                                    window.addToDataLayer({ event: "What is Multi-Factor Authentication?" });
                                                }}
                                            >
                                                {tLang("generateMfa.whatMFALinkText")}
                                            </a>
                                        </p>
                                        <p>
                                            <a
                                                href="#"
                                                className="default_link"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleStaticClick("TemporaryCode");
                                                    window.addToDataLayer({ event: "What is a Temporary Verification Code?" });
                                                }}
                                            >
                                                {tLang("generateMfa.whatIsVerificationCode")}
                                            </a>
                                        </p>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="logo-container" dangerouslySetInnerHTML={{ __html: logoHTML }}></div>
            </div>

            {showDialog && (
                <div className="center-dialog">
                    <DialogComponent dialogId="MFA-INFO-dialog" title="Medical fraud protection" closeDialog={handleCloseDialog}>
                        <MFAInfoDialog dialogData={getData()} />
                    </DialogComponent>
                </div>
            )}
        </React.Fragment>
    );
};

export default VerifyLoginMFA;
